import { z } from 'zod';
import { PlanGroupPermission } from '../../../permission_profile';

export const planPermissionsSchema = z.array(
  z.object({
    group_id: z.number(),
    sources: z.array(z.nativeEnum(PlanGroupPermission)),
    calc: z.array(z.nativeEnum(PlanGroupPermission)),
    can_unlock_periods: z.boolean(),
    release_periods_view: z.boolean().optional(),
    can_edit_statement_panel: z.boolean().optional(),
  }),
);

export const planGroupManagementSchema = z.object({
  plan_permissions: planPermissionsSchema,
});
